module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h2', [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1em",
      "line-height": "1.5",
      "text-indent": "1.5em"
    }
  }, [_vm._v("Gray sat behind his desk waiting for Howard Dunne. The office was so silent that the sudden ring of the telephone was startling. Gray picked up the instrument quickly.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hello?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Harry Zucker speaking. Busy, Mike?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m between patients right now. How’s everything?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I won’t keep you,” Zucker said. “We can talk later. When will you be free?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Say an hour. Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Meet me for a drink. I want to talk to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“All right,” Gray said. “Glad to. What’s the deal?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There was a pause.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ll tell you when I see you,” Zucker said. “Meet me—got a pencil? Well, write this down.” He dictated an address. “I’ll be in the bar.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“But—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“In an hour,” Zucker said, with finality in his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And twenty minutes,” Gray said. “I’ll need time to get—” He realized he was talking to a dead wire. He hung up as he heard the outer door open.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Zucker would have to wait.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“More dreams,” Dunne said, after a while. “I had a piece of paper, rolled up. Like a cylinder. I gave it to you, but you didn’t know it. Funny. I was worried as hell; I knew I had to give it to you, but I had to do it—oh, secretly. The minute I did, I stopped worrying. You turned into somebody else.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s what I’ve been trying to remember,” Dunne said nervously. “My C.O., I think. But I’m not sure. The man who got me shipped out. I told you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I remember,” he said. “And?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t know. But somehow it was all right, after I gave you the paper.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The paper?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sometimes I feel like I’m in an echo chamber,” Dunne said irritably. “You keep repeating my words.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Do you dislike that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I … feel you’re blaming me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Well, isn’t that what you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I guess so,” he said. “It’s a relief. It’s better than waiting. Only … I’m never sure when I’ve told you—the truth. It’s this feeling of helplessness. And yet if I make any move—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What will happen?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The warhead. The proximity fuse. It’ll go off.” Suddenly Dunne began to talk more freely. “I don’t mean anything violent. Not like a scrap. That—maybe that’s just a cover-up. There’s something else I’m afraid of. If it happens … it’s the end. It’s a nightmare. Not even violence. Just the opposite. That’s when I wake up sweating. I’ve been dreaming, and I can’t remember what the dream was. But it’s that—thing I can’t face. A nameless thing—buried.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s why I can’t move,” Dunne said. “I’m safe if I don’t move. But not really. There’s the target and there’s the proximity fuse—me. I can stop moving, but the target won’t stop. It moves toward me. But when I gave you that paper, it was all right, somehow.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What’s the opposite of violence?” Gray asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Death,” Dunne said immediately, and stopped moving. He looked for an instant into something in his own mind.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What are you thinking about?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“My mother … invalid … death. Not moving. Killing … me, because … you’re going to kill me. Christ, that’s crazy. These thoughts don’t mean anything. I don’t mean you. I mean….”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Who do you feel I am?” Gray asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Eleanor,” Dunne said. “Sam. All the people I’ve known … I don’t want to hate you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Because—then you won’t help me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray said, “You have been hating me sometimes. That’s part of therapy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne said unwillingly, “I don’t … yes. Yes, I have.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You should express these feelings,” Gray said. “That’s how to open the way to the feelings that are buried more deeply. And they’re the ones that cause the strongest conflict, because they’re hidden even from yourself. But they’re there. What was that thought?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With a painful effort, Dunne said, “I was wondering what would happen if—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“If?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“If you swear at a man, he gets mad.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“If you feel like swearing at me, you ought to do it,” Gray said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne opened his mouth, hesitated, and shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t really feel like it. I was just wondering.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Why should you want to swear at me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I said it doesn’t mean anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes, that’s so. Or it might mean you want to test me out, to find out if I’ll get mad if you show hostility to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne moved uneasily in his chair.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What are you thinking about?” Gray asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne said, “That typewriter. My father’s—” His face flushed. And suddenly the dam cracked. “Leave me alone!” he snarled. “You bastard! I can’t trust you, I can’t trust anybody—you say I can talk to you, but if I really do, you’ll—you’ll—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray waited. Dunne called him a son of a bitch and stopped, breathing hard.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Before the silence became uncomfortable, the analyst said quietly, “You can say anything else you want to.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne said blankly, “There isn’t anything else.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne thought of something, but drew back from the thought.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No,” he said. “I … I’m all mixed up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“These feelings are painful,” Gray told him. “It isn’t easy to deal with them. But I think you’re making good progress.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The rhythm of Dunne’s breathing changed. He was suddenly more relaxed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I feel better,” he said. “That’s funny. I feel a lot better.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But Gray didn’t. He knew that from now on, Dunne’s behavior would begin to change, and his friends and relatives would react to that. They would feel threatened by the new attitudes in Dunne. Driven by their own unconscious needs, they would protect themselves by trying to force Dunne back into his neurotic pattern.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Almost invariably that was the way it worked out.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He could not wait too long, Gray knew. There would be a time when, for a while, Dunne would become unpredictably unstable. In that case, Gray had three cards to play.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He could bring Dunne back to stability temporarily, even though it meant temporary regression to the old neurotic habits. "), _c('i', [_vm._v("Provided he could")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He could influence Dunne to go to a sanitarium for a time, and continue to treat him there. "), _c('i', [_vm._v("Provided the patient would agree")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Or he could talk to Mary Dunne, Sam Pope, and others, in an attempt to gain information that would lead him most quickly to the information he needed when Dunne finally faced the buried terrors of his own mind.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The analyst could not delay unnecessarily. Dunne should have begun treatment years ago. Now there was only one way to proceed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The proximity fuse must reach its target.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray was the target.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne seemed placid when he left, however. Gray waited a few minutes before he left his office. In the street, he found a taxi and told the driver the address Harry Zucker had given him on the telephone an hour ago.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Oh, sure,” the man said. “That’s "), _c('i', [_vm._v("La Noche")]), _vm._v(", isn’t it?”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fd09eb9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/13_chapter09.vue
// module id = 99
// module chunks = 0